import { ButtonHTMLAttributes } from "react";
import s from "./style.module.scss";
import clsx from "clsx";
import { toggleModal } from "@/core/reatom/state/modal/modal";
import { useAction, useAtom } from "@reatom/npm-react";
import { currentOrderAtom } from "@/core/reatom/state/orders/orders";
interface StatusButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  status:
    | "new"
    | "declined"
    | "cancelled"
    | "not_answered"
    | "accepted"
    | "work_finished"
    | "completed"
    | "fix"
    | "reserved";
}

const titles = {
  new: "Ожидает оплаты",
  declined: "Отказ",
  cancelled: "Отменен",
  not_answered: "Отменен",
  accepted: "В работе",
  work_finished: "Готово",
  completed: "Завершено",
  fix: "Требуется доработка",
  reserved: "Ждет ответа",
  arbitrage: "Арбитраж",
};

export const StatusButton = (props: StatusButtonProps) => {
  const { status } = props;
  const handleToggleModal = useAction(toggleModal);
  const [currentOrder] = useAtom(currentOrderAtom);
  const currentStatus = currentOrder?.is_arbitrage ? "arbitrage" : status;

  return (
    <button
      className={clsx(s.button, s[currentStatus])}
      onClick={() => {
        if (
          [
            // "declined",
            // "cancelled",
            // "accepted",
            // "work_finished",
            // "completed",
            // "fix",
            "arbitrage",
          ].includes(currentStatus)
        )
          handleToggleModal(`status:${currentStatus}`);
      }}
    >
      {titles[currentStatus]}
    </button>
  );
};
